import { render, staticRenderFns } from "./Bospay.vue?vue&type=template&id=7854ef51"
import script from "./Bospay.vue?vue&type=script&lang=js"
export * from "./Bospay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports